import * as React from "react";
import PropTypes from "prop-types";

import Header from "./Header";
import Preview from "./Preview";
import Actions from "./Actions";

const RightSide = ({ loading, onClose, mode }) => {
  return (
    <div className="theme-builder-right-side">
      <Header onClose={onClose} />
      <Preview mode={mode} />
      <Actions loading={loading} />
    </div>
  );
};

RightSide.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

export default RightSide;
